<template>
	<div class="p-grid p-pb-6">
		<div class="p-col-12 p-pt-1 p-pb-1">
        <h2><a href="#/account">{{$t('userinfo.title_parent')}}</a> <img class="p-pl-2 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/> {{$t('userinfo.title')}}</h2>
        <div class="irinox-form">
          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                  <label for="username">{{$t('userinfo.username')}}</label>
                  <InputText id="username" type="email" v-model="userdata.email" :disabled="true" />
              </div>
              <div class="p-field p-col-12 p-md-6" @click="openChangePasswordDialog" :style="!$functions.isDemoMode(email)?'cursor: pointer':''">
                  <label for="password">{{$t('userinfo.password')}}</label>
                  <Password inputId="password" placeholder="********" :disabled="true" />
              </div>
          </div>
          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                  <label for="firstname">{{$t('userinfo.first_name')}}</label>
                  <InputText id="firstname" type="text" v-model="userdata.firstName" 
                    :placeholder="$t('userinfo.first_name_ph')"
                    :class="{'p-invalid':v$.userdata.firstName.$invalid && submitted}"/>
              </div>
              <div class="p-field p-col-12 p-md-6">
                  <label for="lastname">{{$t('userinfo.last_name')}}</label>
                  <InputText id="lastname" type="text" v-model="userdata.lastName" 
                    :placeholder="$t('userinfo.last_name_ph')" 
                    :class="{'p-invalid':v$.userdata.lastName.$invalid && submitted}"/>
              </div>
          </div>
          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                  <label for="email">{{$t('userinfo.email')}}</label>
                  <InputText id="email" type="email" v-model="userdata.email" :disabled="true" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                  <label for="country">{{$t('userinfo.country')}}</label>
                  <Dropdown id="country" v-model="userdata.country" :options="countries" optionLabel="name" optionValue="code" 
                    :placeholder="$t('userinfo.country_ph')" :disabled="true"
                    :class="{'p-invalid':v$.userdata.country.$invalid && submitted}" />
              </div>
          </div>
          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                  <label for="phone">{{$t('userinfo.phone')}}</label>
                  <InputText id="phone" type="phone" v-model="userdata.phone" :placeholder="$t('userinfo.phone_ph')" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                  <label for="address">{{$t('userinfo.address')}}</label>
                  <InputText id="address" type="text" v-model="userdata.address" :placeholder="$t('userinfo.address_ph')" />
              </div>
          </div>
          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                  <label for="city">{{$t('userinfo.city')}}</label>
                  <InputText id="city" type="text" v-model="userdata.city" :placeholder="$t('userinfo.city_ph')" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                  <label for="postalCode">{{$t('userinfo.postalCode')}}</label>
                  <InputText id="postalCode" type="text" v-model="userdata.postalCode" :placeholder="$t('userinfo.postalCode_ph')" />
              </div>
          </div>
        </div>
		</div>
	</div>
  <div class="footer-toolbar">
      <Button v-if="!$functions.isDemoMode(email)" :label="$t('userinfo.delete_button')" class="p-button-outlined p-button-danger on-the-left" @click="openDelete" style="float: left"/>
      <Button v-if="!$functions.isDemoMode(email)" :label="$t('userinfo.logout_button')" class="p-button-secondary" @click="logoutDialogToggle"/>
      <Button :label="$t('userinfo.save_button')" autofocus @click="save(!v$.$invalid)" />
  </div>

  <!-- LOGOUT + COMMON -->

  <IrinoxDialogDark :visible="dialog.logout" mode="confirm" 
    :leftB="$t('userinfo.logout_dialog_cancel_button')" @click:left-button="logoutDialogToggle" 
    :rightB="$t('userinfo.logout_dialog_exit_button')" @click:right-button="logout" 
    :message="$t('userinfo.logout_dialog')"
    icon="assets/irinox/icons/logout.svg" />

  <IrinoxDialogDark :visible="dialog.success" mode="success" :message="$t('userinfo.success_dialog')"
    :life="3000" @update:visible="dialog.success = $event" />

  <IrinoxDialogDark :visible="dialog.error" mode="error" :message="$t('userinfo.error_dialog')"
    :life="3000" @update:visible="dialog.error = $event" />

  <IrinoxDialogDark :visible="dialog.blockingError" mode="error" :message="$t('userinfo.error_dialog')"
    :life="0" @update:visible="dialog.blockingError = $event" />

  <!-- CHANGE PASSWORD -->

  <ChangePasswordDialog :visible="dialog.changePassword"
    @update:visible="dialog.changePassword = $event" 
    @click:button="updatePasswordTemp" />

  <IrinoxDialogDark :visible="dialog.changePasswordSuccess" mode="success" :message="$t('userinfo.updatePassword.success')"
    :life="3000" @update:visible="dialog.changePasswordSuccess = $event" />

  <IrinoxDialogDark :visible="dialog.changePasswordConfirm" mode="confirm" 
    :leftB="$t('userinfo.updatePassword.confirm_dialog_cancel_button')" @click:left-button="() => {
      dialog.changePasswordConfirm = false;
    }" 
    :rightB="$t('userinfo.updatePassword.confirm_dialog_confirm_button')" @click:right-button="updatePassword" 
    :message="$t('userinfo.updatePassword.confirm_dialog')"
    icon="assets/irinox/icons/logout.svg" />

  <!-- DELETE ACCOUNT -->

  <IrinoxDialogDark :visible="dialog.delete" mode="confirm" 
    :leftB="$t('userinfo.delete_dialog_cancel_button')" @click:left-button="() => { dialog.delete = false; }" 
    :rightB="$t('userinfo.delete_dialog_delete_button')" @click:right-button="openDeleteConfirm" 
    :message="$t('userinfo.delete_dialog')"
    icon="assets/irinox/icons/delete_big.svg" />

  <IrinoxDialogDark :visible="dialog.deleteConfirm" mode="confirm" 
    :leftB="$t('userinfo.delete_dialog_confirm_cancel_button')" @click:left-button="() => { dialog.deleteConfirm = false; }" 
    :rightB="$t('userinfo.delete_dialog_confirm_delete_button')" @click:right-button="deleteAccount" 
    :message="$t('userinfo.delete_dialog_confirm')"
    icon="assets/irinox/icons/delete_big.svg" />

  <IrinoxDialogDark :visible="dialog.deleteSuccess" mode="success" :message="$t('userinfo.delete_dialog_success')"
    :life="3000" @update:visible="dialog.deleteSuccess = $event" />

</template>

<script>
import AccountService from '../../service/AccountService';
import CountryService from '../../service/CountryService';
import AiService from '../../service/AiService';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import ChangePasswordDialog from './ChangePasswordDialog.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        IrinoxDialogDark,
        ChangePasswordDialog
    },
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
          userdata: {},
          countries: [],
          submitted: false,
          dialog: {
            logout: false,
            success: false,
            error: false,
            blockingError: false,
            changePassword: false,
            changePasswordConfirm: false,
            changePasswordSuccess: false,
            delete: false,
            deleteConfirm: false,
            deleteSuccess: false,
          },
          updatePasswordData: null
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          email: 'userdata/email',
        }),
    },
    validations() {
        return {
            userdata: {
              firstName: {
                  required
              },
              lastName: {
                  required
              },
              country: {
                  required
              }
            }
        }
    },
    created() {
      this.countryService = new CountryService();
      this.accountService = new AccountService();
        this.aiService = new AiService();
    },
    mounted() {
        this.countryService.getCountries().then((countries) => {
            this.countries = countries;
        });
        this.getUserData();
    },
    methods: {
      getUserData() {
        this.accountService.getUserinfo(this.personaltoken)
          .then(userinfo => {
            this.userdata = userinfo;
            this.$store.commit('userdata/updateUserinfo', userinfo);
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.blockingError = true;
          });
      },
      logoutDialogToggle() {
        this.dialog.logout = !this.dialog.logout;
      },
      logout() {
        this.dialog.logout = false;
        // this.aiService.botDeleteChatSessionHistory(this.personaltoken);
        this.$store.commit('userdata/logout');
      },
      save(isFormValid) {
        this.submitted = true;

        if (!isFormValid) {
          return;
        }

        let updateData = {};
        updateData.country = this.userdata.country;
        updateData.firstName = this.userdata.firstName;
        updateData.lastName = this.userdata.lastName;
        updateData.phone = this.userdata.phone;
        updateData.address = this.userdata.address;
        updateData.city = this.userdata.city;
        updateData.postalCode = this.userdata.postalCode;
        updateData.language = this.userdata.language;
        updateData.preferences = this.userdata.preferences;
        updateData.tos = this.userdata.tos;
        updateData.marketing = this.userdata.marketing;

        this.accountService.putUserinfo(this.personaltoken, updateData)
          .then(() => {
            this.dialog.success = true;
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      },
      updatePasswordTemp(data) {
        this.confirmPasswordData = data;
        this.dialog.changePassword = false;
        this.dialog.changePasswordConfirm = true;
      },
      updatePassword() {
        this.dialog.changePasswordConfirm = false;
        this.accountService.updatePassword(this.personaltoken, this.confirmPasswordData.old, this.confirmPasswordData.new)
          .then((data) => {
            if(data.code=="200") {
              this.confirmPasswordData = null;
              this.dialog.changePasswordSuccess = true;
            } else {
              this.dialog.error = true;
              setTimeout(function() {
                this.dialog.changePassword = true;
              }.bind(this), 3000);
              console.error("EXCEPTION "+JSON.stringify(data));
            }
          })
          .catch(error => {
            this.confirmPasswordData = null;
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      },
      openDelete() {
        this.dialog.delete = true;
      },
      openDeleteConfirm() {
        this.dialog.delete = false;
        this.dialog.deleteConfirm = true;
      },
      deleteAccount() {
        this.dialog.deleteConfirm = false;
        this.accountService.selfDeleteUser(this.personaltoken)
          .then((data) => {
            if(data.code=="200") {
              this.dialog.deleteSuccess = true;
              setTimeout(function() {
                this.logout();
              }.bind(this), 3000);
            } else {
              console.error("EXCEPTION "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
        
      },
      openChangePasswordDialog() {
        if(!this.$functions.isDemoMode(this.email)) {
          this.dialog.changePassword = true;
        }
      }
    }
}
</script>

<style>

</style>